<template>
	<!-- note: will be rendered in ui-config -->
	<div class="wrapper">
		<!-- Success -->
		<div class="box" v-if="version === '4'">
			<div>
				<div class="headline">Payment was successful</div>
				<div class="text">
					Thank you, your payment was successful, you can leave this page now.
				</div>
			</div>
		</div>

		<!-- Failure -->
		<div class="box" v-else-if="version === '6'">
			<div>
				<div class="headline error">Payment failed</div>
				<div class="text error">
					The payment failed. Maybe you entered incorrect card number or you
					have insufficient funds.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		version() {
			return this.$route.query.version ? this.$route.query.version : null
		}
	}
}
</script>

<style scoped>
.wrapper {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
	min-height: 100vh;
	padding-top: 64px;
	background: #f8f8f9;
}

.box {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	width: 80%;
	max-width: 520px;
	min-height: 200px;
	background: white;
	border: 1px solid rgb(230, 230, 230);
	border-radius: 4px;
	padding: 16px;
}

.headline {
	display: block;
	width: 100%;
	text-align: center;
	font-size: 26px;
	font-weight: 700;
	margin-top: -16px;
	margin-bottom: 8px;
	color: rgb(50, 200, 50);
}

.text {
	width: 100%;
	text-align: center;
	color: rgb(60, 60, 60);
}

.error {
	color: rgb(250, 50, 50);
}
</style>